module.exports = "/_next/static/images/77bf8119bfec50dc8f4f61ae7aed5bdc-girl-holding-phone@1x.jpg.webp";